export default __webpack_public_path__ + "static/twitter-1728dfb89a72b9a42395ded33fcf87d7.svg";